import classNames from 'classnames';

import { Pressable } from '../../../shared/ui';

export interface IEmoList {
  items: string[];
  selectedEmo?: string[];
  onEmotionClick?: (emo: string, selected: string[]) => void;
  /** Мобильный 1:1: эмоции — компактные «таблетки» в несколько в ряд, а не по одной на всю ширину */
  mobile?: boolean;
}

export const EmoList = ({ items, selectedEmo, onEmotionClick, mobile = false }: IEmoList) => {
  if (mobile) {
    return (
      <div className="flex flex-wrap gap-2">
        {items.map((item) => {
          const selected = Boolean(selectedEmo?.includes(item));

          return (
            <Pressable
              key={item}
              aria-pressed={selected}
              disabled={!onEmotionClick || !selectedEmo}
              className={classNames(
                'rounded-full border px-3 py-1.5 text-ui font-medium transition-colors',
                selected ? 'border-accent bg-accent text-ink' : 'border-transparent bg-black/20 text-white',
              )}
              onClick={onEmotionClick && selectedEmo ? () => onEmotionClick(item, selectedEmo) : undefined}
            >
              {item}
            </Pressable>
          );
        })}
      </div>
    );
  }

  return (
    <div>
      <div className="flex md:flex-col gap-[15px_12px] flex-wrap items-center">
        {items.map((item, idx) => (
          <div
            key={`${item}-idx`}
            className={classNames(
              'w-full max-w-[240px] 2xl:max-w-[360px] rounded-chip py-[2px] px-0 lg:p-[5px_10px] text-center text-body-l-strong mx-auto border cursor-pointer transition-all duration-150',
              {
                'bg-ink/60 text-white border-transparent hover:border-accent': !(
                  selectedEmo && selectedEmo.includes(item)
                ),
                'bg-accent text-ink border-accent-ink shadow-[0_0_0_2px_rgba(211,179,100,0.25)] hover:border-ink':
                  selectedEmo && selectedEmo.includes(item),
              },
            )}
            onClick={onEmotionClick && selectedEmo ? () => onEmotionClick(item, selectedEmo) : undefined}
          >
            {item}
          </div>
        ))}
      </div>
    </div>
  );
};
